module.exports = __webpack_public_path__ + "img/test-delect-active.c474956d.svg";